import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { addExpense } from "../../store/slices/expense";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

import { uploadadminImage } from "../../utils/helpers/fileupload";
import { pdf } from "@react-pdf/renderer";
import ExpenseReceipt from "../admin/expenseReceipt";


const getAcademicSession = () => {

  const today = new Date();

  const currentYear = today.getFullYear();

  const currentMonth = today.getMonth();


  // January, February, March

  if (currentMonth <= 2) {

    return `${currentYear - 1} -${String(currentYear).slice(-2)} `;

  }


  // April to December

  return `${currentYear} -${String(currentYear + 1).slice(-2)} `;

};


const requiredMessages = {

  session: "Please select session",

  name: "Please enter expense name",

  amount: "Please enter amount",

  towards: "Please enter expense towards",

  paymentMode: "Please select payment mode",

  date: "Please select date",

};


export default function AddExpense() {

  let user = JSON.parse(
    localStorage.getItem("user")
  );

  const token = user?.data?.accessToken;

  const navigate = useNavigate();

  const dispatch = useDispatch();


  const currentSession = getAcademicSession();

  const [startYear] = currentSession.split("-");


  const sessions = [

    `${Number(startYear) - 1} -${String(Number(startYear)).slice(-2)} `,

    currentSession,

  ];


  const [formData, setFormData] = useState({

    session: "",

    name: "",

    amount: "",

    towards: "",

    paymentMode: "",

    date: "",

    remarks: "",

    bill: "",

  });


  const [errors, setErrors] = useState({});


  const validateField = (name, value) => {

    let error = "";


    if (requiredMessages[name] && !value) {

      error = requiredMessages[name];

    }


    if (
      name === "amount" &&
      value &&
      Number(value) <= 0
    ) {

      error = "Amount must be greater than zero";

    }


    setErrors((prev) => ({

      ...prev,

      [name]: error,

    }));

  };


  const handleChange = (e) => {

    const { name, value } = e.target;

    let updatedValue = value;


    if (name === "amount") {

      updatedValue = value
        .replace(/\D/g, "")
        .slice(0, 7);

    }


    setFormData((prev) => ({

      ...prev,

      [name]: updatedValue,

    }));


    validateField(
      name,
      updatedValue
    );

  };


  const handleFileChange = (e) => {

    const { name, files } = e.target;

    const file = files?.[0];


    if (!file) return;


    const allowedTypes = [

      "application/pdf",

      "image/jpeg",

      "image/jpg",

      "image/png",

      "image/webp",

    ];


    if (!allowedTypes.includes(file.type)) {

      toast.error(
        "Only PDF, JPG, JPEG, PNG and WEBP files are allowed."
      );

      e.target.value = "";

      return;

    }


    if (file.size > 5 * 1024 * 1024) {

      toast.error(
        "File size must not exceed 5 MB."
      );

      e.target.value = "";

      return;

    }


    setFormData((prev) => ({

      ...prev,

      [name]: file,

    }));

  };


  const handleSubmit = async (e) => {

    e.preventDefault();


    const newErrors = {};


    Object.keys(requiredMessages).forEach(
      (field) => {

        if (!formData[field]) {

          newErrors[field] =
            requiredMessages[field];

        }

      }
    );


    setErrors(newErrors);


    if (Object.keys(newErrors).length) {

      toast.error(
        "Please correct the form errors"
      );

      return;

    }


    try {

      // ==========================================
      // UPLOAD BILL
      // ==========================================

      let billUrl = "";


      if (formData.bill instanceof File) {

        billUrl = await uploadadminImage(
          formData.bill,
          token
        );

      }


      // ==========================================
      // PAYLOAD
      // ==========================================

      const payload = {

        session: formData.session,

        name: formData.name.trim(),

        amount: Number(formData.amount),

        towards: formData.towards.trim(),

        paymentMode: formData.paymentMode,

        date: formData.date,

        remarks: formData.remarks.trim(),

        bill: billUrl || "",

      };


      // ==========================================
      // SAVE EXPENSE
      // ==========================================

      const response = await dispatch(
        addExpense(payload)
      ).unwrap();


      // ==========================================
      // GET EXPENSE + INSTITUTE
      // ==========================================

      const expense = response.data;

      const institute = response.institute;


      console.log(
        "Created Expense:",
        expense
      );

      console.log(
        "Institute:",
        institute
      );


      // ==========================================
      // GENERATE EXPENSE RECEIPT
      // ==========================================

      const blob = await pdf(

        <ExpenseReceipt
          expense={expense}
          institute={institute}
        />

      ).toBlob();


      // ==========================================
      // OPEN PDF
      // ==========================================

      const pdfUrl =
        URL.createObjectURL(blob);


      window.open(
        pdfUrl,
        "_blank"
      );


      // ==========================================
      // SUCCESS
      // ==========================================

      toast.success(
        "Expense added successfully"
      );


      // ==========================================
      // NAVIGATE
      // ==========================================

      navigate(
        "/accounts/expense"
      );


    } catch (err) {

      console.error(
        "Add expense error:",
        err
      );


      toast.error(
        err?.message ||
        "Failed to add expense"
      );

    }

  };


  return (

    <>

      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">

            <div className="home-icon">

              <Link to="/institute/home">

                <FiHome
                  style={{
                    color: "white",
                    marginTop: "-4px"
                  }}
                />

              </Link>

            </div>


            <FiChevronRight
              className="separator"
            />


            <Link to="/accounts/expense">

              Expenses

            </Link>


            <FiChevronRight
              className="separator"
            />


            <span className="active">

              Add Expense

            </span>

          </div>

        </div>

      </div>


      <div className="acs-card">

        <form
          className="form-grid"
          onSubmit={handleSubmit}
        >


          {/* Session */}

          <div className="form-group">

            <label>
              Session
            </label>


            <select
              name="session"
              value={formData.session}
              onChange={handleChange}
            >

              <option value="">
                Select Session
              </option>


              {sessions.map((item) => (

                <option
                  key={item}
                  value={item}
                >

                  {item}

                </option>

              ))}

            </select>


            {errors.session && (

              <small className="error-text">

                {errors.session}

              </small>

            )}

          </div>


          {/* Expense Name */}

          <div className="form-group">

            <label>
              Name
            </label>


            <input
              type="text"
              name="name"
              placeholder="Enter name"
              value={formData.name}
              maxLength={75}
              onChange={handleChange}
            />


            {errors.name && (

              <small className="error-text">

                {errors.name}

              </small>

            )}

          </div>


          {/* Towards */}

          <div className="form-group">

            <label>
              Towards
            </label>


            <input
              type="text"
              name="towards"
              placeholder="Eg. Electricity, Salary"
              value={formData.towards}
              maxLength={75}
              onChange={handleChange}
            />


            {errors.towards && (

              <small className="error-text">

                {errors.towards}

              </small>

            )}

          </div>


          {/* Amount */}

          <div className="form-group">

            <label>
              Amount
            </label>


            <input
              type="text"
              name="amount"
              placeholder="Enter amount"
              value={formData.amount}
              maxLength={7}
              inputMode="numeric"

              onChange={(e) => {

                const value =
                  e.target.value
                    .replace(/\D/g, "")
                    .slice(0, 7);


                setFormData((prev) => ({

                  ...prev,

                  amount: value,

                }));


                validateField(
                  "amount",
                  value
                );

              }}


              onKeyDown={(e) => {

                if (
                  [
                    "e",
                    "E",
                    "+",
                    "-",
                    "."
                  ].includes(e.key)
                ) {

                  e.preventDefault();

                }

              }}

            />


            {errors.amount && (

              <small className="error-text">

                {errors.amount}

              </small>

            )}

          </div>


          {/* Payment Mode */}

          <div className="form-group">

            <label>
              Payment Mode
            </label>


            <select
              name="paymentMode"
              value={formData.paymentMode}
              onChange={handleChange}
            >

              <option value="">
                Select Payment Mode
              </option>

              <option value="Cash">
                Cash
              </option>

              <option value="UPI">
                UPI
              </option>

              <option value="Cheque">
                Cheque
              </option>

              <option value="Bank Transfer">
                Bank Transfer
              </option>

              <option value="Card">
                Card
              </option>

              <option value="Other">
                Other
              </option>

            </select>


            {errors.paymentMode && (

              <small className="error-text">

                {errors.paymentMode}

              </small>

            )}

          </div>


          {/* Date */}

          <div className="form-group">

            <label>
              Date
            </label>


            <input
              type="date"
              name="date"
              value={formData.date}
              max={
                new Date()
                  .toISOString()
                  .split("T")[0]
              }
              onChange={handleChange}
            />


            {errors.date && (

              <small className="error-text">

                {errors.date}

              </small>

            )}

          </div>


          {/* Bill */}

          <div className="form-group">

            <label>
              Bill
            </label>


            <input
              type="file"
              name="bill"
              accept=".pdf,.jpg,.jpeg,.png,.webp"
              onChange={handleFileChange}
            />

          </div>


          {/* Actions */}

          <div className="form-actions mt-5">

            <button
              type="button"
              className="btn-cancel"
              onClick={() => navigate(-1)}
            >

              Cancel

            </button>


            <button
              type="submit"
              className="btn-submit"
            >

              Submit

            </button>

          </div>


        </form>

      </div>

    </>

  );

}
